/**
 * Menu script
 */
 class ME_Menu {
	constructor() {
		this.initState();
		this.initEvents();
	}

	initState() {
		this.win = $(window);
		this.menuWrapper = $('#header');
		this.menuIcon = this.menuWrapper.find('.mobile-menu-wrapper');
		this.menuBlock = this.menuWrapper.find('.bottom-menu');
		this.menuBlockClose = this.menuBlock.find('.bottom-menu-close');
	}

	initEvents() {
		$(window).on('scroll', () => {
			let positionY = this.win.scrollTop();

			if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
					this.menuWrapper.addClass('is-fixed');
					return;
			}

			if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
					this.menuWrapper.removeClass('is-fixed');
			}
	});
	
		this.menuIcon.on('click', e => {
			e.preventDefault();
			this.menuBlock.toggleClass('active');
			$(document.body).toggleClass('no-scroll');
		});

		if (this.menuBlockClose.length) {
			this.menuBlockClose.on('click', e => {
				e.preventDefault();
				this.menuBlock.removeClass('active');
				this.menuBlock.find('.menu-left > li').removeClass('mobile-active');
				$(document.body).removeClass('no-scroll');
			});
		}

		this.menuBlock.find('.bottom-menu-back').on('click', e => {
			e.preventDefault();
			this.menuBlock.removeClass('submenu');
			this.menuBlock.find('.menu-left > li').removeClass('mobile-active');
		})
	
		this.menuBlock.find('.menu-left .deeper.parent > a').on('click', e => {
			let submenuLink = $(e.target);
			var submenuLinkParent = submenuLink.parent();
			var isMobile = $(window).outerWidth() <= 1024;
	
			if (isMobile && !submenuLinkParent.hasClass('mobile-active')) {
				e.preventDefault();
				this.menuBlock.addClass('submenu');
				this.menuBlock.find('.menu-left > li').removeClass('mobile-active');
				submenuLinkParent.addClass('mobile-active');
			}
		})
	}
}
